/* 130R — chassi salvo neste aparelho (localStorage) e anexado a toda conversa de WhatsApp com a 130R.
   - Painel: snippets/r130-chassi.liquid, aberto por qualquer link com [data-r130-chassi-abrir].
   - Campos onde o cliente informa o carro: [data-r130-chassi-campo] (snippets/r130-chassi-campo.liquid);
     o valor "misto" aceita também carro/ano digitado e só salva quando é um chassi. */
(function () {
  var CHAVE = 'r130_chassi';
  var FONES = ['5511910801297'];
  var MSG_SALVO = 'Chassi salvo. Vai junto quando você chamar no WhatsApp.';
  var abrirOriginal = window.open;
  var dlg = document.getElementById('r130-chassi');

  function ler() {
    try { var v = JSON.parse(localStorage.getItem(CHAVE) || 'null'); return v && v.vin ? v.vin : ''; } catch (e) { return ''; }
  }
  function gravar(vin) {
    var antes = ler();
    try {
      if (vin) localStorage.setItem(CHAVE, JSON.stringify({ vin: vin, em: new Date().toISOString().slice(0, 10) }));
      else localStorage.removeItem(CHAVE);
    } catch (e) {}
    // Medição (assets/r130-medicao.js): avisa que o chassi mudou. O evento não leva o chassi, só se salvou ou apagou.
    if ((vin || '') !== antes) { try { document.dispatchEvent(new CustomEvent('r130:chassi', { detail: { salvo: !!vin } })); } catch (e) {} }
  }
  // Chassi não usa I, O e Q: quem digita essas letras quis dizer 1 e 0.
  function normalizar(s) { return String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, '').replace(/[OQ]/g, '0').replace(/I/g, '1'); }
  function valido(v) { return /^[A-HJ-NPR-Z0-9]{17}$/.test(v); }

  // Só conversas com a 130R: link de compartilhar (sem número ou com outro número) não leva o chassi.
  function ehWhats130R(url) {
    url = String(url || '');
    if (!/^(https?:\/\/(wa\.me|api\.whatsapp\.com|web\.whatsapp\.com)\/|whatsapp:\/\/)/i.test(url)) return false;
    return FONES.some(function (f) { return url.indexOf(f) !== -1; });
  }

  // Acrescenta o chassi ao parâmetro text, sem duplicar e sem trocar %20 por + (o wa.me mostra o +).
  // 19/10/2026 (agente veiculo-motor, aprovado pelo Marcus): antes do chassi, o carro e o motor do "Meu carro"
  // (window.R130CarroWa, assets/r130-carro-wa.js). Sem aquele arquivo, só o chassi, como antes.
  function comCarro(t) { try { return window.R130CarroWa ? window.R130CarroWa.completar(t) : t; } catch (e) { return t; } }
  function comChassi(url, vin) {
    url = String(url || '');
    vin = vin || ler();
    if (!ehWhats130R(url) || ((!vin || url.indexOf(vin) !== -1) && !window.R130CarroWa)) return url;
    try {
      var semAncora = url.split('#')[0];
      var i = semAncora.indexOf('?');
      var base = i < 0 ? semAncora : semAncora.slice(0, i);
      var params = i < 0 ? [] : semAncora.slice(i + 1).split('&').filter(Boolean);
      var achou = false;
      params = params.map(function (p) {
        var j = p.indexOf('=');
        if ((j < 0 ? p : p.slice(0, j)) !== 'text') return p;
        achou = true;
        var t = decodeURIComponent((j < 0 ? '' : p.slice(j + 1)).replace(/\+/g, ' '));
        var original = t;
        t = comCarro(t);
        if (vin && t.indexOf(vin) === -1) {
          // Mensagem que já pede o chassi (ex.: "Número do Chassi ou Placa:" em branco): preenche ali mesmo.
          var campoVazio = /^(.*chassi[^:\n]*:)[ \t]*$/im;
          t = campoVazio.test(t) ? t.replace(campoVazio, '$1 ' + vin) : (t ? t + '\n\n' : '') + 'Chassi: ' + vin;
        }
        if (t === original) return p;   // nada a acrescentar: o link fica como estava
        return 'text=' + encodeURIComponent(t);
      });
      if (!achou) {
        var t0 = comCarro('');
        if (vin) t0 = (t0 ? t0 + '\n\n' : '') + 'Chassi: ' + vin;
        if (t0) params.push('text=' + encodeURIComponent(t0));
      }
      return base + '?' + params.join('&');
    } catch (e) { return url; }
  }

  /* ---------- campos de chassi pelo site ---------- */
  function ehCampo(el) { return el && el.matches && el.matches('[data-r130-chassi-campo]'); }
  function ehMisto(c) { return c.getAttribute('data-r130-chassi-campo') === 'misto'; }
  function avisar(c, msg, estado) {
    var bloco = c.closest('[data-r130-chassi-bloco]');
    var info = bloco && bloco.querySelector('[data-r130-chassi-info]');
    c.setAttribute('aria-invalid', estado === 'erro' ? 'true' : 'false');
    if (!info) return;
    if (!info.hasAttribute('data-padrao')) info.setAttribute('data-padrao', info.textContent);
    info.textContent = msg || info.getAttribute('data-padrao');
    if (estado) info.setAttribute('data-estado', estado); else info.removeAttribute('data-estado');
  }
  // Põe o chassi salvo nos campos (menos o que a pessoa está digitando) e avisa o script da página.
  function preencher(raiz, origem) {
    var vin = ler();
    (raiz || document).querySelectorAll('[data-r130-chassi-campo]').forEach(function (c) {
      if (c === origem || c === document.activeElement) return;
      var atual = normalizar(c.value);
      if (ehMisto(c) && c.value && !valido(atual)) return; // não apaga o carro/ano digitado
      if (atual === vin) return;
      c.value = vin;
      avisar(c, vin ? MSG_SALVO : '', vin ? 'ok' : '');
      c.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }
  function atualizarRotulos() {
    var vin = ler();
    document.querySelectorAll('[data-r130-chassi-rotulo]').forEach(function (el) {
      el.textContent = vin ? 'Chassi final ' + vin.slice(-6) : (el.getAttribute('data-padrao') || '');
    });
  }
  function sincronizar(origem) { atualizarRotulos(); preencher(document, origem); }

  document.addEventListener('input', function (ev) {
    var c = ev.target;
    if (!ehCampo(c) || !ev.isTrusted) return;
    var v = normalizar(c.value);
    if (valido(v)) {
      if (v !== ler()) { gravar(v); sincronizar(c); }
      avisar(c, MSG_SALVO, 'ok');
    } else if (!ehMisto(c)) {
      avisar(c, v ? v.length + ' de 17 caracteres' : '', v ? 'conta' : '');
    }
  });
  document.addEventListener('change', function (ev) {
    var c = ev.target;
    if (!ehCampo(c) || !ev.isTrusted || ehMisto(c)) return;
    var v = normalizar(c.value);
    if (!v) {
      if (ler()) { gravar(''); sincronizar(c); avisar(c, 'Chassi apagado deste aparelho.', ''); }
      return;
    }
    if (!valido(v)) avisar(c, 'O chassi tem 17 letras e números. Você digitou ' + v.length + '.', 'erro');
  });
  // Enter no campo de chassi não envia o formulário do carro: só confere o que foi digitado.
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Enter' && ehCampo(ev.target) && !ehMisto(ev.target)) { ev.preventDefault(); ev.target.blur(); }
  });

  // Seletores que aparecem depois da carga (ex.: o filtro das coleções).
  if (window.MutationObserver) {
    new MutationObserver(function (lista) {
      lista.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1 && (ehCampo(n) || n.querySelector('[data-r130-chassi-campo]'))) preencher(n.parentNode || n);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------- links de WhatsApp ---------- */
  function aoClicar(ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
    if (!a || !ehWhats130R(a.href)) return;
    if (ev.type === 'click' && a.hasAttribute('data-r130-chassi-abrir') && dlg && dlg.showModal) {
      ev.preventDefault();
      abrirPainel();
      return;
    }
    a.href = comChassi(a.href);
  }
  document.addEventListener('click', aoClicar, true);
  document.addEventListener('auxclick', aoClicar, true);

  // Apps que abrem o WhatsApp por script (ex.: o botão flutuante).
  window.open = function (url) {
    var args = Array.prototype.slice.call(arguments);
    if (url && ehWhats130R(url)) args[0] = comChassi(String(url));
    return abrirOriginal.apply(window, args);
  };

  document.addEventListener('desktop-lazyloaded', atualizarRotulos);
  sincronizar();

  /* ---------- painel ---------- */
  if (!dlg || !dlg.showModal) return;

  var form = dlg.querySelector('form');
  var campo = dlg.querySelector('#r130-chassi-campo');
  var conta = dlg.querySelector('[data-r130-chassi-conta]');
  var erro = dlg.querySelector('#r130-chassi-erro');
  var apagar = dlg.querySelector('[data-r130-chassi-apagar]');

  function contar() { conta.textContent = normalizar(campo.value).length + '/17'; }
  function mostrarErro(msg) {
    erro.textContent = msg;
    erro.hidden = !msg;
    campo.setAttribute('aria-invalid', msg ? 'true' : 'false');
    if (msg) campo.focus();
  }
  function abrirPainel() {
    var vin = ler();
    campo.value = vin;
    apagar.hidden = !vin;
    mostrarErro('');
    contar();
    dlg.showModal();
    campo.focus();
  }
  // Devolve o chassi normalizado, '' se o campo está vazio, ou null se é inválido (já mostra o erro).
  function chassiDoCampo(obrigatorio) {
    var v = normalizar(campo.value);
    if (!v) {
      if (obrigatorio) { mostrarErro('Digite o chassi para salvar.'); return null; }
      return '';
    }
    if (!valido(v)) { mostrarErro('O chassi tem 17 letras e números. Você digitou ' + v.length + '.'); return null; }
    return v;
  }
  function mensagem(vin) {
    var m = dlg.getAttribute('data-msg') || '';
    var peca = dlg.getAttribute('data-peca');
    if (peca) m += '\n\nPeça: ' + peca + '\n' + location.href.split('?')[0];
    m = comCarro(m);   // carro e motor do "Meu carro" (19/10/2026)
    if (vin) m += '\n\nChassi: ' + vin;
    return m;
  }

  campo.addEventListener('input', function () { contar(); if (!erro.hidden) mostrarErro(''); });

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    var vin = chassiDoCampo(false);
    if (vin === null) return;
    if (vin) { gravar(vin); sincronizar(); }
    var url = 'https://wa.me/' + dlg.getAttribute('data-fone') + '?text=' + encodeURIComponent(mensagem(vin));
    abrirOriginal.call(window, url, '_blank', 'noopener');
    dlg.close();
  });

  dlg.querySelector('[data-r130-chassi-salvar]').addEventListener('click', function () {
    var vin = chassiDoCampo(true);
    if (!vin) return;
    gravar(vin);
    sincronizar();
    dlg.close();
  });

  apagar.addEventListener('click', function () {
    gravar('');
    campo.value = '';
    apagar.hidden = true;
    contar();
    sincronizar();
    campo.focus();
  });

  dlg.querySelector('[data-r130-chassi-fechar]').addEventListener('click', function () { dlg.close(); });
  dlg.addEventListener('click', function (ev) { if (ev.target === dlg) dlg.close(); });
})();
